import { render } from "./DonationForm.vue?vue&type=template&id=4df63a22&scoped=true&lang=html"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"

import "./DonationForm.vue?vue&type=style&index=0&id=4df63a22&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df63a22"]])

export default __exports__